import React from 'react';
import { Flex, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface DateUpdateFlexRowProps {
    title?: string,
    lastUpdated: number | undefined, 
    refreshCallback: () => void
}

export const DateUpdateFlexRow = (props: DateUpdateFlexRowProps) => {
    
    const {title, lastUpdated, refreshCallback} = props;

    const formatDate = (date: number) => {
        return new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        }).format(date);
    };

    return (   
        <Flex justify='flex-end' style={{margin: '15px'}}>
            <Space>
            <p>Last data fetch: {lastUpdated ? formatDate(lastUpdated) : "No fetch"}</p>
            <p>
                <ReloadOutlined 
                title={title ?? 'Reload data'}
                style={{cursor: 'pointer'}}
                onClick={refreshCallback}
                />
            </p>
            </Space>
        </Flex>
    );
}
